import { useState } from "react";
import styles from "./FaqSection.module.css";
import { GoPlus } from "react-icons/go";
import { LuMinus, LuPlus } from "react-icons/lu";

function FaqItem({ item, isOpen, onToggle }) {
  return (
    <div className={`${styles.item} ${isOpen ? styles.itemOpen : ""}`} onClick={onToggle}>
      <button
        type="button"
        className={`${styles.question} ${isOpen ? styles.itemOpenQuestion : ""}`}

        aria-expanded={isOpen}
      >
        <span className={styles.questiontext}>{item.question}</span>
        <span className={`${styles.toggle} ${isOpen ? styles.toggleOpen : ""}`} aria-hidden="true">
          {isOpen ? <LuMinus /> : <LuPlus />}
        </span>
      </button>
      {isOpen ? (
        <div className={styles.answer}>
          {typeof item.answer === "string" ? <p>{item.answer}</p> : item.answer}
        </div>
      ) : null}
    </div>
  );
}

export default function FaqSection({
  items = [],
  title = "Frequently Asked Questions (FAQs)",
  defaultOpenId,
  className = "",
  listClassName = "",
}) {
  const [openId, setOpenId] = useState();

  if (!items.length) return null;

  return (
    <section className={`standard-padding ${styles.section} ${className}`.trim()}>
      {title ? <h2 className="standard-heading">{title}</h2> : null}
      <div className={`${styles.list} ${listClassName}`.trim()}>
        {items.map((item, index) => {
          const id = item.id ?? String(index);

          return (
            <FaqItem
              key={id}
              item={item}
              isOpen={openId === id}
              onToggle={() => setOpenId((prev) => (prev === id ? "" : id))}
            />
          );
        })}
      </div>
    </section>
  );
}
